import styled from 'styled-components';
import { textTransform } from 'utils';

export const CinemaRentInquiryWrapper = styled.div.attrs({
  className: 'cinema-rent'
})`
  h2 {
    font-weight: 450;
    font-size: 24px;
    line-height: 34px;
    letter-spacing: 1px;
    text-transform: ${textTransform};
    margin-top: 29px;
  }

  .cinema-rent__title {
    letter-spacing: 1.5px;
    margin-top: 30px;
  }

  h3 {
    font-weight: 390;
    font-size: 16px;
    line-height: 24px;
    margin-top: 35px;
  }

  .cinema-rent__divider {
    border: 3px solid rgba(151, 151, 151, 0.8);
    margin-top: 39px;
  }

  .cinema-rent__data-inputs-wrapper {
    margin-top: 40px;

    .cinema-rent__data-header {
      display: flex;
      justify-content: space-between;

      .cinema-rent__data-header-cinema {
        display: flex;
        align-items: center;
        cursor: pointer;

        .svg-right-arrow-normal {
          height: 32px;
          width: 32px;
          fill: #de1619;
        }
      }

      h3 {
        color: #de1619;
        margin: 0;
      }
    }

    h2 {
      letter-spacing: 1.5px;
      margin: 0;
    }

    .cinema-rent__inputs-wrapper {
      margin-top: 18px;
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      column-gap: 23px;
      row-gap: 20px;
    }

    @media (max-width: 768px) {
      .cinema-rent__inputs-wrapper {
        grid-template-columns: repeat(2, 1fr);
      }
    }
  }

  .cinema-rent__divider-sm {
    border: 1px solid rgba(151, 151, 151, 0.8);
    margin-top: 50px;
  }

  .cinema-rent__programs-events-wrapper {
    margin-top: 28px;
    display: flex;
    justify-content: space-between;

    @media (max-width: 768px) {
      flex-direction: column;
    }

    .cinema-rent__program-wrapper {
      h2 {
        margin: 0;
      }
      .cinema-rent__program-container {
        .cinema-rent__program-radio {
          display: flex;
          align-items: center;
          margin-top: 15px;
          padding: 0;
          cursor: pointer;
          color: #FFFFFF;

          h3 {
            font-size: 18px;
            margin: 0 0 0 10px;
          }
        }

        .cinema-rent__program-inclusive-films-wrapper {
          margin-left: 72px;
        }

        .cinema-rent__program-input {
          margin-top: 15px;
          width: 288px;
        }
      }
    }

    .cinema-rent__event-wrapper {
      h2 {
        margin: 0;
      }
      .cinema-rent__event-container {
        display: flex;

        @media (max-width: 768px) {
          flex-direction: column;
        }

        .cinema-rent__event-left {
          margin-right: 34px;
        }

        .cinema-rent__event-input {
          margin-top: 15px;
          width: 288px;
        }

        .cinema-rent__event-checkbox {
          display: flex;
          align-items: center;
          margin-top: 15px;
          cursor: pointer;
          padding: 0;
          color: #FFFFFF;
          
          h3 {
            font-size: 18px;
            margin: 0 0 0 10px;
          }
        }
      }
    }
  }

  .cinema-rent__divider-hall {
    border: 1px solid rgba(151, 151, 151, 0.8);
    margin-top: 39px;
  }

  .cinema-rent__hall-capacity-wrapper {
    margin-top: 28px;

    .cinema-rent__hall-capacity-container {
      .cinema-rent__hall-radio {
        display: flex;
        align-items: center;
        margin-top: 15px;
        padding: 0;
        cursor: pointer;
        color: #FFFFFF;

        h3 {
          font-size: 18px;
          margin: 0 0 0 10px;
        }
      }
    }
  }

  .cinema-rent__technic-concession-wrapper {
    margin-top: 31px;
    display: flex;
    justify-content: space-between;

    @media (max-width: 768px) {
      flex-direction: column;
    }

    .cinema-rent__technic-wrapper {
      h2 {
        margin: 0;
      }
      .cinema-rent__technic-concession-container {
        display: flex;

        .cinema-rent__technic-content {
          margin-right: 6px;
        }

        .cinema-rent__technic-concession-checkbox {
          display: flex;
          align-items: center;
          margin-top: 16px;
          padding: 0;
          cursor: pointer;
          color: #FFFFFF;
          
          h3 {
            font-size: 18px;
            margin: 0 0 0 10px;
          }
        }
        .cinema-rent__technic-concession-input {
          margin-top: 16px;
          width: 288px;
        }
      }
      .cinema-rent__technic-concession-container-right {
        display: flex;

        @media (max-width: 768px) {
          flex-direction: column;
        }
        .cinema-rent__concession-content {
          margin-right: 140px;
        }
        .cinema-rent__technic-concession-checkbox {
          display: flex;
          align-items: center;
          margin-top: 16px;
          padding: 0;
          cursor: pointer;
          color: #FFFFFF;
          
          h3 {
            font-size: 18px;
            margin: 0 0 0 10px;
          }
        }
        .cinema-rent__technic-concession-input {
          margin-top: 16px;
          width: 288px;
        }
      }

      @media (max-width: 768px) {
        .cinema-rent__technic-concession-container {
          flex-direction: column;
        }
      }
    }
  }
  .cinema-rent__divider-date {
    border: 1px solid rgba(151, 151, 151, 0.8);
    margin-top: 42px;
  }

  .cinema-rent__preferred-date-wrapper {
    margin-top: 31px;
    margin-bottom: 5px;
    display: flex;
    justify-content: space-between;

    @media (max-width: 768px) {
      flex-direction: column;
    }

    h2 {
      margin: 0;
    }

    .cinema-rent__preferred-date-input {
      margin-top: 11px;
      width: 288px;

      &:first-child {
        margin-right: 7px;
      }
    }

    .cinema-rent__preferred-date-time-frame {
      display: flex;
      margin-top: 10px;

      @media (max-width: 768px) {
        flex-direction: column;
      }
    }
  }

  .cinema-rent-divider-addition-info {
    border: 1px solid rgba(151, 151, 151, 0.8);
    margin-top: 42px;
  }

  .cinema-rent__additional-info-wrapper {
    margin-top: 32px;

    .cinema-rent__additional-info-message {
      margin-top: 13px;
    }

    .lg-screen-area {
      font-size: 1.5rem;
    }

    .cinema-rent__attachment-info {
      font-style: italic;
      font-weight: 330;
      font-size: 16px;
      line-height: 24px;
      margin-top: 31px;
    }

    .cinema-rent__attachment-wrapper {
      margin-top: 11px;
      display: flex;
      align-items: center;

      .cinema-rent__attachment-input {
        display: none;
      }

      .cinema-rent__attachment-btn {
        width: 288px;
      }

      h3 {
        font-weight: 390;
        font-size: 16px;
        line-height: 24px;
        color: #888888;
        margin:  0 0 0 12px;
      }
    }

    .cinema-rent__terms-wrapper {
      margin-top: 31px;

      .cinema-rent__terms-checkbox {
        display: flex;
        align-items: center;
        margin-top: 16px;
        padding: 0;
        cursor: pointer;
        color: #FFFFFF;
        
        h3 {
          font-size: 18px;
          margin: 0 0 0 10px;
        }

        .cinema-rent__terms-link {
          text-decoration: underline;
        }
      }
    }

    .cinema-rent__required-fields {
      margin-top: 35px;
    }
  }
  .cinema-rent__divider-send {
    border: 3px solid rgba(151, 151, 151, 0.8);
    margin-top: 41px;
  }
.captcha{
  margin-top: 4rem;
}
  .cinema-rent__send-btn {
    margin: 36px 0 68px;
    width: 288px;
  }
`;

export default CinemaRentInquiryWrapper;
